<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">おしらせ</span>{{ this.notice.title }}</h1>
      <div class="l-contentsBox">
        <div class="l-infoDetail">
          <div class="l-infoDetail__body">
            <div class="l-infoDetail__box">
              <div class="l-infoDetail__text">
                <span class="l-contentsTitle__sub" style="margin-bottom: 30px;padding: 0;"><span class="info-catlabel" style="margin-right: 10px;margin-left: 0;">{{ this.notice.noticeTypeLabel }}</span> 掲載日： {{ $dayjs(this.notice.fromDt).format("YYYY/MM/DD") }}</span>
                <p style="white-space: pre-line;">{{ notice.content }}</p>
              </div>
              <div class="l-infoDetail__info">
                <div class="l-solutionDetail__download" v-if="notice.file">
                  <h3>資料ダウンロード</h3>
                  <div class="l-solutionDetail__thum" v-if="thumbNailImageFile">
                    <img :src="thumbNailImageFile" alt="" style="max-width: 100%; height: auto; width /***/:auto;">
                  </div>
                  <a @click="download()">{{ this.fileName }}（{{ file.size }}MB）</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="l-pageNav">
        <li @click="getNotice(previous.noticeId)">
          <template v-if="previous.noticeId">
            <a>{{ previousNoticeTitle }}</a>
          </template>
        </li>
        <li @click="goNoticeList()"><a>お知らせ一覧</a></li>
        <li @click="getNotice(next.noticeId)">
          <template v-if="next.noticeId">
            <a>{{ nextNoticeTitle }}</a>
          </template>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import constant from '@/const';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      notice: {
        title: '',
        mailSendKbnLabel: '',
        noticeTypeLabel: '',
        mailSendTargetLabel: '',
        file: {
          size: 0,
        }
      },
      previous: {
        noticeId: null,
        title: '',
      },
      next: {
        noticeId: null,
        title: '',
      },
      current:{
        noticeId: null,
      },
      file: {
        fileNm: ''
      },
      thumbNailImageFile: '',
    }
  },
  computed: {
    fileName() {
      return this.file ? this.file.fileNm : '';
    },
    noticeId() {
      return this.$store.getters['portal/getNoticeId'];
    },
    previousNoticeTitle() {
      if (!this.previous.noticeId) return '';
      return (this.previous.title.length > 20)
        ? (this.previous.title).slice(0, 20) + '...'
        : this.previous.title;
    },
    nextNoticeTitle() {
      if (!this.next.noticeId) return '';
      return (this.next.title.length > 20)
        ? (this.next.title).slice(0, 20) + '...'
        : this.next.title;
    },
  },
  created: async function() {
    await this.getNotice(this.noticeId);
  },
  methods: {
    async getNotice(noticeId) {
      this.current.noticeId = noticeId;

      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/notice/getNotice', {
        noticeId: noticeId,
      });
      if (res) {
        this.notice = res.data.notice;
        this.file = res.data.notice.file
        this.previous = res.data.previousNotice;
        this.next = res.data.nextNotice;
        this.thumbNailImageFile = res.data.thumbNailImageFile;
        this.setLabel();
      }
      this.isProcessing = false;
    },
    setLabel() {
      const tmpMailSendKbn = this.notice.mailSendKbn;
      let mailSendKbn = constant.MAIL_SEND_KBN.find(function(element){
        return element.value === tmpMailSendKbn;
      }, tmpMailSendKbn);
      this.notice.mailSendKbnLabel = mailSendKbn.label;

      const tmpNoticeType = this.notice.noticeType;
      let noticeType = constant.NOTICE_TYPE.find(function(element){
        return element.value === tmpNoticeType;
      }, tmpNoticeType);
      this.notice.noticeTypeLabel = noticeType.label;

      const tmpMailSendTarget = this.notice.mailSendTarget;
      let mailSendTarget = constant.MAIL_SEND_TARGET.find(function(element){
        return element.value === tmpMailSendTarget;
      }, tmpMailSendTarget);
      this.notice.mailSendTargetLabel = mailSendTarget.label;
    },
    async download() {
      let url='/ld/api/notice/downloadFile?id=' + this.current.noticeId;
      await saveAs(url);
    },
    goNoticeList() {
      this.$router.push({ name: 'notice-list' });
    }
  },
}

</script>
